// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3678 ? "47bf8baf" : chunkId) + "." + {"3621":"efc4d3efb2293de1","3678":"08cad4a1bd0dbc0e","8254":"0e0119bee43b4234"}[chunkId] + ".js";
};